import React from 'react';

import { TabPanelProps } from './TabPanel.props';

export const TabPanel: React.FC<TabPanelProps> = ({
  children,
  index,
  value,
  keepMounted = false,
}) => {
  const isActive = value === index;
  return (
    <div
      role="tabpanel"
      hidden={!isActive}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={keepMounted && !isActive ? { display: 'none' } : undefined}
    >
      {(isActive || keepMounted) && children}
    </div>
  );
};
